import { render, staticRenderFns } from "./CommonPage.vue?vue&type=template&id=10f9a510&scoped=true&"
import script from "./CommonPage.vue?vue&type=script&lang=js&"
export * from "./CommonPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f9a510",
  null
  
)

export default component.exports